export const getValidateCode = (codeLength: number) => (code: string) =>
  !code || code.length === codeLength || 'Fill in all the verification code fields';
